import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateLoader, Translation } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { selectTranslations } from "./widget/state/selectors";

// import * as TranslationsDE from '../../public/i18n/de.json';
// import * as TranslationsEN from '../../public/i18n/en.json';

export class CustomTranslationLoader implements TranslateLoader {
constructor(private store: Store) {}
  public getTranslation(lang: string): Observable<Translation|string> {
        return this.store.select(selectTranslations)
  }
}



// const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
//   new TranslateHttpLoader(http, 'https://aws.traduction.rate-match.com/translations/?locales=', '&id=11277');